import { useMutation } from "@tanstack/react-query";
import { START_QA_PROVISION_JOB } from "../api/queries";
import { graphQLClient } from "../graphqlClient";
import type { StartQaProvisionJobInput } from "@/types/qaProvision";

/**
 * Queue a QA climber provisioning job. Returns the job id to poll with
 * {@link useQaProvisionJob}; validation failures (not a district admin, a
 * section outside your district, a manifest that doesn't parse) come back here
 * as errors rather than as a failed job.
 */
export const useStartQaProvisionJob = () => {
  const mutation = useMutation({
    mutationFn: async (input: StartQaProvisionJobInput): Promise<string> => {
      const response = await graphQLClient.request<{
        startQaProvisionJob: { jobId: string } | null;
      }>(START_QA_PROVISION_JOB, { input });
      const jobId = response.startQaProvisionJob?.jobId;
      if (!jobId) throw new Error("No job id returned.");
      return jobId;
    },
  });

  return {
    startJob: mutation.mutateAsync,
    isStarting: mutation.isPending,
    error: mutation.error as Error | null,
    reset: mutation.reset,
  };
};
